import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const CalendarSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="calendar-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        viewBox="0 0 16 18"
        data-testid="calendar-svg"
      >
        <defs>
          <path
            id="calendar"
            d="M17.328 6.625c.232 0 .422-.19.422-.422V4.937c0-.931-.756-1.687-1.688-1.687h-1.687V1.422c0-.232-.19-.422-.422-.422h-1.406c-.232 0-.422.19-.422.422V3.25h-4.5V1.422c0-.232-.19-.422-.422-.422H5.797c-.232 0-.422.19-.422.422V3.25H3.687C2.756 3.25 2 4.006 2 4.937v1.266c0 .232.19.422.422.422h14.906zM16.062 19c.932 0 1.688-.756 1.688-1.688v-9.14c0-.232-.19-.422-.422-.422H2.422c-.232 0-.422.19-.422.422v9.14C2 18.244 2.756 19 3.687 19h12.375z"
          />
        </defs>
        <g fill="none" transform="translate(-2 -1)">
          <use fill="#0B0B0B" xlinkHref="#calendar" />
          <use fill="#070B16" xlinkHref="#calendar" />
        </g>
      </svg>
    </StyledContainer>
  );
};

export default CalendarSVG;
